var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 140.3",
    style: {
      enableBackground: "new 0 0 125 140.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D374B;}\n\t.st1{fill:#28A0F0;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#96BEDC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-light",
    transform: "translate(41.509 -145.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "translate(-219 92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    className: "st0",
    d: "M255.8,117.5l10.3-17.5l27.8,43.3l0,8.3l-0.1-57.1c-0.1-1.4-0.8-2.7-2-3.4l-50-28.8 c-1.2-0.6-2.6-0.6-3.8,0c-0.2,0.1-0.3,0.2-0.4,0.3l-0.2,0.1l-48.5,28.1l-0.2,0.1c-0.3,0.1-0.5,0.3-0.7,0.4 c-0.9,0.7-1.5,1.6-1.7,2.7c0,0.2-0.1,0.3-0.1,0.5l0.1,46.6l25.9-40.1c3.3-5.3,10.4-7,16.9-6.9l7.7,0.2l-45.6,73.1l5.4,3.1 l46.1-76.1l20.4-0.1l-46,78l19.2,11l2.3,1.3c1,0.4,2.1,0.4,3.1,0.1l50.7-29.4l-9.7,5.6L255.8,117.5z M259.7,174.1l-19.4-30.4 l11.8-20l25.4,40.1L259.7,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    className: "st1",
    d: "M240.4,143.7l19.4,30.4l17.9-10.4l-25.4-40.1L240.4,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    className: "st1",
    d: "M293.9,151.6l0-8.3L266.1,100l-10.3,17.5l26.8,43.4l9.7-5.6c0.9-0.8,1.5-1.9,1.6-3.1 L293.9,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    className: "st2",
    d: "M177.5,159.4l13.7,7.9l45.6-73.1L229,94c-6.6-0.1-13.7,1.6-16.9,6.9l-25.9,40.1l-8.7,13.4 L177.5,159.4L177.5,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    className: "st2",
    d: "M263,94.2l-20.4,0.1l-46.1,76.1l16.1,9.3l4.4-7.4L263,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    className: "st3",
    d: "M302.5,94.1c-0.2-4.3-2.5-8.2-6.1-10.4l-50.7-29.1c-3.7-1.8-8-1.8-11.6,0 c-0.4,0.2-49.3,28.5-49.3,28.5c-0.7,0.3-1.3,0.7-1.9,1.1c-3.2,2.3-5.2,5.9-5.4,9.9v60.3l8.7-13.4l-0.1-46.6 c0.1-1.3,0.7-2.5,1.8-3.2c0.2-0.2,49.9-28.9,50.1-29c1.2-0.6,2.6-0.6,3.8,0l50,28.8c1.2,0.8,1.9,2,2,3.4v57.7 c0,1.2-0.6,2.4-1.5,3.1l-9.7,5.6l-5,2.9l-17.9,10.4l-18.1,10.5c-1,0.4-2.1,0.3-3.1-0.1L217,172.2l-4.4,7.4l19.3,11.1 c0.6,0.4,1.2,0.7,1.7,0.9c0.7,0.4,1.2,0.7,1.4,0.8c1.6,0.7,3.4,1.1,5.1,1.1c1.6,0,3.2-0.3,4.7-0.9l52.7-30.5c3-2.3,4.8-5.9,5-9.7 L302.5,94.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.55134659951e1fc68cc2f3b586f1c1e2.svg";
export { ForwardRef as ReactComponent };